<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<script>
import SquareLoader from '@src/components/SquareLoader.vue';
import { useCurrentStudyStore } from '@src/store/dicom-web/current-study-store';
import { computed, defineComponent, ref } from 'vue';

import { useViewportStateStore } from '@/src/store/contours/viewport-state-store';

export default defineComponent({
  name: 'SeriesThumbnailsOverlay',
  components: {
    SquareLoader,
  },
  setup() {
    const isDragging = ref(false);
    const currentStudyStore = useCurrentStudyStore();

    const seriesList = computed(
      () => currentStudyStore.activeStudy.series,
    );

    const thumbnails = computed(
      () => currentStudyStore.getSeriesThumbnails,
    );

    const seriesDescriptions = computed(
      () => currentStudyStore.getSeriesThumbnailDescriptions,
    );

    const seriesDimensions = computed(
      () => currentStudyStore.getSeriesDimensions,
    );

    const thumbnailClicked = (index) => {
      const viewportStateStore = useViewportStateStore();
      const generalViewerViewID = 'AnalysisGeneralView';
      const indices = {
        seriesIdx: index,
        sliceIdx: 0,
        imageIdx: 0,
      };

      viewportStateStore.setSelectedImageIndices(generalViewerViewID, indices);
    };

    const startDrag = (event, index) => {
      isDragging.value = true;

      event.dataTransfer.dropEffect = 'move';

      event.dataTransfer.effectAllowed = 'move';
      const indices = {
        seriesIdx: index,
        sliceIdx: 0,
        imageIdx: 0,
      };
      event.dataTransfer.setData('ImageIndices', JSON.stringify(indices));
    };

    return {
      currentStudyStore,
      seriesList,
      thumbnails,
      seriesDescriptions,
      seriesDimensions,
      startDrag,
      thumbnailClicked,
    };
  },
});
</script>

<template>
  <div class="flex flex-col w-full gap-2">
    <div>
      <h5>Series:</h5>
    </div>
    <div class="thumbnails">
      <div
        v-for="(series, index) in seriesList"
        :key="index"
        class="thumbnail"
      >
        <div
          draggable="true"
          @dragstart="startDrag($event, index)"
          @click="thumbnailClicked(index)"
        >
          <div class="small-thumbnail-image">
            <img
              v-if="thumbnails[index]"
              :id="index"
              :src="thumbnails[index]"
              class="w-full h-full object-cover"
              :alt="`Thumbnail ${index + 1}`"
            >
            <SquareLoader v-else />
            <div
              v-if="seriesDimensions[index] || (series.slices && series.slices[0])"
              class="series-chip simple-panel px-2 py-1"
            >
              <strong>{{ index + 1 }}</strong> ({{
                seriesDimensions[index]?.sliceCount ?? series.slices.length
              }}/{{
                seriesDimensions[index]?.phaseCount ?? series.slices[0].images.length
              }})
            </div>
          </div>
        </div>
        <div class="break-words" style="width: var(--small-thumbnail-width)">
          <p>
            {{
              seriesDescriptions[index]
                || currentStudyStore.seriesInfoDicom[series.uid]?.SeriesDescription
                || '(no series description)'
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.thumbnails {
  display: grid;
  justify-content: center;
  align-content: flex-start;
  height: 100%;
  overflow: auto;
  grid-template-columns: repeat(auto-fill, minmax(var(--small-thumbnail-width), 1fr));
  row-gap: 10px;
  gap: 5px;
}

.thumbnail {
  cursor: pointer;
}

.thumbnail:hover {
  filter: brightness(120%);
}

.small-thumbnail-image {
  position: relative;
}

.series-chip {
  position: absolute;
  bottom: 6px;
  right: 6px;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1;
  pointer-events: none;
}
</style>
